import Vue from 'vue'
import App from './App.vue'
import request from "@/utils/request"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.request=request

new Vue({
  render: h => h(App),
}).$mount('#app')
